module.exports = new __parcel__URL__("bp.17919c8e.avif").toString();